export * from './lib/shared-ui-accordions.module';
